import DownloadBVLife from 'components/home/DownloadBVLife';
import Loyalty from 'components/home/Loyalty';
import FooterHome from 'components/layout/Footer/FooterHome';
import { getAuth } from 'functions';
import useDevice from 'hooks/useDevice';
import authActions from 'model/actions/auth';
import InfoUser from 'pages/HomePage/InfoUser';
import MenuHome from 'pages/HomePage/MenuHome';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import HeaderAndMenu from '../HeaderAndMenu';

function MainLayout(props) {
	const { children } = props;
	const auth = getAuth();
	const dispatch = useDispatch();

	const { isMobile } = useDevice();

	useEffect(() => {
		if (auth) {
			dispatch(authActions.getUserProfile(auth?.userCode));
		}
	}, []);

	const renderChildren = useMemo(() => {
		if (!isMobile && auth) {
			return (
				<>
					<HeaderAndMenu />
					<div className='flex-1 md:px-24px flex'>
						<div className='rounded-8px z-10 w-full md:w-400px flex-shrink-0 bg-account bg-top bg-100% -mt-30px md:-mt-50px'>
							<div className='rounded-8px border border-EEEEEE overflow-hidden md:shadow-md bg-white'>
								<InfoUser isMobile={isMobile} />
								<MenuHome />
							</div>
							<DownloadBVLife />
							<Loyalty isMobile={isMobile} />
							<FooterHome />
						</div>
						<div className='content-pages flex-1 md:pl-24px py-20px scroll-min'>
							{children}
						</div>
					</div>
				</>
			);
		}
		return <div>{children}</div>;
	}, [children]);

	return (
		<div className='bg-F2F2EF md:overflow-hidden flex flex-col h-screen'>
			{renderChildren}
		</div>
	);
}

export default MainLayout;
